import type { EditionUpgradeCTAProps } from '../whiteboard-bridge-api-type';

export type UpgradeHandler = (options: EditionUpgradeCTAProps) => Promise<void>;

export class WhiteboardEditionUpgradeService {
	#upgradeHandler: UpgradeHandler = async () => {};
	#closeHandler: () => void = () => {};

	registerUpgradeHandler(upgradeHandler: UpgradeHandler) {
		this.#upgradeHandler = upgradeHandler;
	}

	registerCloseHandler(closeHandler: () => void) {
		this.#closeHandler = closeHandler;
	}

	// Show CTA with provided options
	// Upgrade handler returns deferred Promise that resolves when CTA is closed
	showUpgradeExperience(options: EditionUpgradeCTAProps) {
		return this.#upgradeHandler(options);
	}

	// Method exposed to bridge API for allowing whiteboards to
	// close paywall CTA
	closeUpgradeExperience() {
		this.#closeHandler();
	}
}
